import {
  actionCreator,
  BUSINESS_NAME_API,
  checkHttpStatus,
  FORGOT_PASSWORD_API,
  handleFirstLoginAfterSignUp,
  handleLoginRedirect,
  handleLogoutRedirect,
  handleSecurityQuestionRedirect,
  jsonApiHeader,
  LOGIN_API,
  LOGOUT_API,
  loginActionTypes,
  REFRESH_TOKEN,
  RESET_PASSWORD_API } from './../constants/ApiConstants';
  import {
    PatientDashboardActionTypes
  } from './../../containers/dashboard/constants/ApiConstants';
  
import GlobalVariables, {calculateTimeZone, filterNonISO8859OrLimitToASCII} from '../../../../actions/utilAction';
import { showSuccessMessage } from '../../../Masters/components/userRoles/constants/ApiConstants';
import moment from 'moment';

/**
 * @todo check business name
 * @desc get subdomain name from url and take it as business name.
 *       Check business name and return message if business name not subscribed.
 *        /VerifyBusinessName?BusinessName
 */
export function checkBusinessName(businessName) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.check_business_name.REQUEST));
    fetch(`${BUSINESS_NAME_API}?BusinessName=${businessName}`, {
      method: 'get',
      headers: jsonApiHeader(null, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if (response.statusCode === 200) {
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: response.data.businessToken, businessCheckMessage: null, organizationDetails: response.data.organization }));
        }
        if (response.statusCode === 401) {
          dispatch(actionCreator(loginActionTypes.check_business_name.SUCCESS, { access_token: null, businessCheckMessage: response.message }));
        }
      }).catch(function(error) {
        console.log('error logs: ', error);
      });
  };
}

export function PatientloginAction(authData, businessNameCheck) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_login.REQUEST));
    fetch(`${LOGIN_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      // headers: {
      //   'Content-Type': 'application/json',
      //   'businessToken': businessNameCheck,
      // },
      headers: {
        'Content-Type': 'application/json',
        'businessToken': businessNameCheck,
        'Timezone': filterNonISO8859OrLimitToASCII(calculateTimeZone()),//converting the non-iso string with iso/empty string,
        'IPAddress': GlobalVariables.IpAddress,
        'Offset': moment().utcOffset(),
        //'LocationID': GlobalVariables.CurrentLocationId ? GlobalVariables.CurrentLocationId : 0,
      },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        if ((response.statusCode >= 400 && response.statusCode < 500) && response.message) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
        } else if (response.statusCode === 205) {
          let errorMessage = response.message;
          dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { response: response, errorMessage: errorMessage, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency: false }));
        } else {
          if (response.access_token) {
            if (response.data.users3.userRoles.roleName === 'Client') {
              let currentLocationId = response.data.locationID;
              GlobalVariables.CurrentLocationId = currentLocationId;
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: currentLocationId, access_token: response.access_token, loginUserInfo: response.data, isOnlyForAgency : false }));
              dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, {passwordExpiryStatus: response.passwordExpiryStatus}));
              //handleLoginRedirect(response.access_token, authData, '/client-dashboard');
              handleLoginRedirect(response.access_token, authData, '/my-profile');
            }
          } else {
            if (response.firstTimeLogin && response.firstTimeLogin === true) {
              handleSecurityQuestionRedirect(response, authData);
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency : false }));
            } else {
              handleFirstLoginAfterSignUp(response, authData);
              dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: null, access_token: null, loginUserInfo: null, isOnlyForAgency : false }));
            }
          }
        }
      }).catch(function(error) {
        console.log('error logs: ', error);
        let errorMessage = 'Invalid username or password.';
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: errorMessage, access_token: null, loginUserInfo: null }));
      });
  };

}


// export function logoutAction() {
//   return (dispatch) => {
//     dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
//     handleLogoutRedirect('/client-login');
//   };
// }
export function logoutAction() {  
  return (dispatch, getState) => {
      dispatch(actionCreator(loginActionTypes.logout_user.REQUEST));
      fetch(`${LOGOUT_API}`, {
        method: 'PATCH',
        headers: jsonApiHeader(getState().login.access_token, 'application/json'),
      })
        .then(checkHttpStatus)
        .then(function (response) {
          dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
          handleLogoutRedirect('/client-login');
        }).catch(function (error) {
          console.log(error);
          //let errorMessage = 'Oops, something went wrong, please try later';
          dispatch(actionCreator(loginActionTypes.logout_user.SUCCESS));
          handleLogoutRedirect('/client-login');
        });
    };  
}


export function refreshAuthToken(old_token) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.refresh_token.REQUEST));
    fetch(`${REFRESH_TOKEN}`, {
      method: 'get',
      headers: jsonApiHeader(old_token, 'application/json'),
    })
      .then(checkHttpStatus)
      .then(function(response) {
        dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, access_token: response.access_token, loginUserInfo: response.data, isOnlyForAgency : false }));
        // dispatch(actionCreator(PatientDashboardActionTypes.get_CheckUserPasswordStatus.SUCCESS, {passwordExpiryStatus: response.passwordExpiryStatus}));
        //handleLoginRedirect(response.access_token, '', '/client-dashboard');
        handleLoginRedirect(response.access_token, '', '/my-profile');
      }).catch(function(error) {
        console.log(error);
        dispatch(actionCreator(loginActionTypes.post_login.FAILURE, { errorMessage: ' ', access_token: null, loginUserInfo: null }));
        handleLogoutRedirect('/client-login');
      });
  };
}

export function forgotPasswordAction(authData) {
  //authData.ResetPasswordURL = 'http://localhost:3000/reset-password';
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_forgotPassword.REQUEST));
    fetch(`${FORGOT_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        let successMessage = 'Forgot password request processed successfully. Please check your registered email for further instructions.';
        showSuccessMessage(successMessage);
        // Alert.success(successMessage, {
        //   position: 'top',
        //   effect: 'slide',
        // });
        dispatch(actionCreator(loginActionTypes.post_forgotPassword.SUCCESS));
        handleLogoutRedirect('/client-login');
      }).catch(function(error) {
        console.log('error: ', error);
        let errorMessage = 'Invalid username or email';
        dispatch(actionCreator(loginActionTypes.post_forgotPassword.FAILURE, { errorMessage: errorMessage }));
      });
  };
}

export function ResetPasswordAction(authData) {
  return (dispatch) => {
    dispatch(actionCreator(loginActionTypes.post_resetPassword.REQUEST));
    fetch(`${RESET_PASSWORD_API}`, {
      method: 'post',
      body: JSON.stringify(authData),
      headers: { 'Content-Type': 'application/json' },
    })
      .then(checkHttpStatus)
      .then(function(response) {
        showSuccessMessage('Password reset successfully! Please login with new credentials.');
        // Alert.success('Password reset successfully! Please login with new credentials.', {
        //   position: 'top',
        //   effect: 'slide',
        // });
        dispatch(actionCreator(loginActionTypes.post_resetPassword.SUCCESS));
        handleLogoutRedirect('/client-login');
      }).catch(function(error) {
        console.log('error: ', error);
        let errorMessage = 'Invalid user credentials';
        dispatch(actionCreator(loginActionTypes.post_resetPassword.FAILURE, { errorMessage: errorMessage }));
      });
  };
}

// export function verifyUserToken(token) {
//   return (dispatch) => {
//     fetch(`${VERIFY_TOKEN_API}`, {
//       method: 'post',
//       body: JSON.stringify(token),
//       headers: { 'Content-Type': 'application/json' },
//     })
//     .then(checkHttpStatus)
//     .then(function(response) {

//     })
//     .catch(function(error) {
//       console.log('error: ', error);
//       handleLogoutRedirect();
//     });
//   };
// }

// export function changeLocationAction(locationId, loginInfo) {
//   return (dispatch, getState) => {
//     dispatch(actionCreator(loginActionTypes.post_login.SUCCESS, { errorMessage: null, currentLocationId: locationId, access_token: getState().login.access_token, loginUserInfo: loginInfo, isOnlyForAgency : false }));
//   };
// }



// WEBPACK FOOTER //
// ./src/modules/PatientPortal/logins/actions/LoginActions.js